<div class='competitions-container'>

  <h2> Acquisto </h2>

  <app-product-list *ngIf='competitionPayment' [configuration]='competitionPayment'></app-product-list>

</div>
